import { useEffect } from "react";
import { Music } from "../components/sections/Music";
import { MediaKit } from "../components/sections/MediaKit";
import { Contact } from "../components/sections/Contact";

export default function MusicPage() {
  useEffect(() => {
    document.title = "Music — REYCRO | Beats · Production · DJ";
  }, []);

  return (
    <div className="pt-16 md:pt-20">
      <Music />
      <MediaKit />
      <Contact />
    </div>
  );
}
